<template>
  <div class="layout error-layout">
    <div class="error-page">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorLayout',
};
</script>
